import { PhysicalProductItemErrorsType } from '../../types/product-interface'

export const defaultErrors: PhysicalProductItemErrorsType = {
  title: '',
  subTitle: '',
  buttonTitle: '',
  thumbnail: '',
  ['checkoutPage.title']: '',
  ['checkoutPage.buttonTitle']: '',
  ['checkoutPage.description']: '',
  ['checkoutPage.fields']: '',
  ['checkoutPage.coverId']: '',
  ['thankYouPage.title']: '',
  ['thankYouPage.text']: '',
  ['digitalStore.paymentMethods']: '',
  ['checkoutPage.physicalProductId']: '',
}
